import React from 'react';

import Portal from '../../../general/components/Portal';

import Area from './Area';

const Wrapper = () => (
    <Portal container="legend-area">
        <Area />
    </Portal>
);

export default Wrapper;
